import defaultMapStyles from './defaultMapStyles'
import { KeplerMapStyle, MapStyleType } from './types'
import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/state/store'
import { BasemapSettings } from 'features/account/types'

const EMPTY_ARRAY = []
export const mapStylesWithLayerGroupsSelector = createSelector(
  (state: RootState) => state.builder.mapStyles,
  (mapStyles) =>
    mapStyles.map((style) => {
      const originalDefinition = defaultMapStyles.find((defaultStyle) => defaultStyle.id === style.id)
      return {
        ...style,
        layerGroups: originalDefinition?.layerGroups || EMPTY_ARRAY
      }
    })
)

export const fallbackMapStyleSelector = createSelector(
  (state: RootState) => state.builder.mapStyles,
  (state: RootState) => state.builder.basemapSettings,
  (mapStyles: KeplerMapStyle[], basemapSettings: BasemapSettings) => {
    if (basemapSettings?.carto) {
      const cartoCandidate = mapStyles.find((style) => style.type === MapStyleType.MAPLIBRE && !style.disabled)
      if (cartoCandidate) {
        return cartoCandidate
      }
    }

    if (basemapSettings?.custom) {
      const customCandidate = mapStyles.find((style) => style.type === MapStyleType.CUSTOM && !style.disabled)
      if (customCandidate) {
        return customCandidate
      }
    }

    if (basemapSettings?.google) {
      const googleCandidate = mapStyles.find((style) => style.type === MapStyleType.GOOGLE_MAPS && !style.disabled)
      if (googleCandidate) {
        return googleCandidate
      }
    }
    return defaultMapStyles[0]
  }
)

export const defaultMapStyleSelector = fallbackMapStyleSelector

export default defaultMapStyles
